{
  "comment": "M3 relinking (plan R19, spec §6.3, D-TBD 12/13). Distances in metres, speeds in m/s, times in seconds. parts: the repair list per region (the region of the system you repair from), times longRelayMult for a long relay, rounded up. reboot: defence time per region, the objective's hull, the AI siege weight (raiders weigh the relay at distance / weight), where waves spawn around the relay, how far inside the rim from the repair port the objective sits (the ring's aperture is open, so aimed fire needs a point inside the rim), the despawn distance of reboot spawns, the waves per region, guardians (when a tetherstone-vein system is within `hops` relay hops) and allied patrols (when the owner patrols). laneRepair: a down lane ring within rangeM takes these parts. Starting values, tune freely.",
  "autoScanM": 5000,
  "portRangeM": 500,
  "portMaxSpeed": 30,
  "leaveAbortM": 30000,
  "parts": {
    "gate": { "hull_plating": 6, "electronics": 3, "drive_parts": 2 },
    "mid": { "hull_plating": 12, "electronics": 6, "drive_parts": 4 },
    "deep": { "hull_plating": 18, "electronics": 9, "drive_parts": 6 },
    "rim": { "hull_plating": 24, "electronics": 12, "drive_parts": 8 }
  },
  "longRelayMult": 1.5,
  "reboot": {
    "seconds": { "gate": 180, "mid": 210, "deep": 240, "rim": 300 },
    "hull": 4000,
    "siegeWeight": 2,
    "spawnRadiusM": [2500, 4000],
    "objectiveInsetM": 30,
    "despawnM": 40000,
    "waves": {
      "gate": [
        { "atS": 20, "ships": [{ "def": "interceptor", "profile": "rookie", "count": 2 }] },
        { "atS": 100, "ships": [{ "def": "interceptor", "profile": "rookie", "count": 2 }] }
      ],
      "mid": [
        { "atS": 20, "ships": [{ "def": "interceptor", "profile": "rookie", "count": 2 }] },
        { "atS": 90, "ships": [{ "def": "interceptor", "profile": "veteran", "count": 2 }] },
        { "atS": 160, "ships": [{ "def": "gunship", "profile": "rookie", "count": 1 }, { "def": "interceptor", "profile": "rookie", "count": 2 }] }
      ],
      "deep": [
        { "atS": 20, "ships": [{ "def": "interceptor", "profile": "veteran", "count": 2 }] },
        { "atS": 90, "ships": [{ "def": "gunship", "profile": "veteran", "count": 1 }, { "def": "interceptor", "profile": "veteran", "count": 1 }] },
        { "atS": 170, "ships": [{ "def": "interceptor", "profile": "ace", "count": 2 }] }
      ],
      "rim": [
        { "atS": 20, "ships": [{ "def": "interceptor", "profile": "veteran", "count": 3 }] },
        { "atS": 110, "ships": [{ "def": "gunship", "profile": "veteran", "count": 2 }] },
        { "atS": 200, "ships": [{ "def": "interceptor", "profile": "ace", "count": 3 }] }
      ]
    },
    "guardians": { "hops": 2, "atFraction": 0.5, "ships": [{ "def": "guardian_interceptor", "profile": "veteran", "count": 2 }] },
    "allies": { "chance": 0.6, "radiusM": [400, 900], "ships": [{ "def": "patrol_interceptor", "profile": "veteran", "count": 2 }] }
  },
  "laneRepair": { "rangeM": 300, "parts": { "hull_plating": 2, "electronics": 1 } }
}
